import { useEffect } from 'react'

declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

// ⚠️ REEMPLAZA con tu Measurement ID real de Google Analytics 4
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'

function gtag(...args: any[]) {
  if (window.gtag) {
    window.gtag(...args)
  }
}

export function useGoogleAnalytics() {
  useEffect(() => {
    if (window.gtag) return

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: true,
    })

    // Load gtag.js script
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    // --- Conversion Events ---

    // Track ViewContent when offer section is visible
    let viewItemFired = false
    const offerSection = document.getElementById('oferta')
    if (offerSection) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !viewItemFired) {
            viewItemFired = true
            gtag('event', 'view_item', {
              currency: 'USD',
              value: 12,
              items: [
                {
                  item_id: 'REFLUJO-CERO-72H',
                  item_name: 'Reflujo Cero en 72h',
                  price: 12,
                  quantity: 1,
                },
              ],
            })
            observer.disconnect()
          }
        },
        { threshold: 0.3 },
      )
      observer.observe(offerSection)
    }

    // Track CTA clicks
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const anchor = target.closest(
        'a[href], button',
      ) as HTMLAnchorElement | null
      if (!anchor) return
      const href = anchor.getAttribute('href') || ''

      // Scroll to CTA = add_to_cart
      if (href === '#cta-final') {
        gtag('event', 'add_to_cart', {
          currency: 'USD',
          value: 12,
          items: [
            {
              item_id: 'REFLUJO-CERO-72H',
              item_name: 'Reflujo Cero en 72h',
              price: 12,
              quantity: 1,
            },
          ],
        })
      }

      // Click Hotmart = begin_checkout + generate_lead
      if (href.includes('pay.hotmart.com')) {
        gtag('event', 'begin_checkout', {
          currency: 'USD',
          value: 12,
          items: [
            {
              item_id: 'REFLUJO-CERO-72H',
              item_name: 'Reflujo Cero en 72h',
              price: 12,
              quantity: 1,
            },
          ],
        })
        gtag('event', 'generate_lead', {
          currency: 'USD',
          value: 12,
        })
      }
    }

    document.addEventListener('click', handleClick, true)

    // Track scroll depth milestones
    const milestones = new Set<number>()
    const handleScroll = () => {
      const pct = Math.round(
        ((window.scrollY + window.innerHeight) /
          document.documentElement.scrollHeight) *
          100,
      )
      ;[25, 50, 75, 90].forEach((m) => {
        if (pct >= m && !milestones.has(m)) {
          milestones.add(m)
          gtag('event', 'scroll_depth', {
            percent_scrolled: m,
            page_title: document.title,
          })
        }
      })
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      document.removeEventListener('click', handleClick, true)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
}
